module.exports = __webpack_public_path__ + "static/img/22.9ed633c.png";


//////////////////
// WEBPACK FOOTER
// ./static/goumai/22.png
// module id = sm6M
// module chunks = 14